import gql from "graphql-tag";

export default {
update: gql`
    mutation UpdatePhotoboothChoiceCell ($input: UpdatePhotoboothChoiceCellInput!) {
        updatePhotoboothChoiceCell (input: $input) {
            id
            email
            qr_code
            print
            border_color
            text_color
        }
    }`,

get: gql`
    query PhotoboothChoiceCell($id: ID!) {
        photoboothChoiceCell(id: $id) {
            id
            email
            qr_code
            print
            border_color
            text_color
        }
    }`
}